var raf = require('raf');

module.exports.request = raf;
module.exports.cancel = raf.cancel;
